import { UnitConditionPipe } from './unit.condition.pipe';

export function UnitConditionFilter ( unitConditionPipe : UnitConditionPipe ) {
  return ( isNew : boolean ) : string => unitConditionPipe.transform(isNew);
};
